import { Component, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { WizardListElement } from './../../../_shared/model/wizardListElement.model';
import { HelperService } from './../../../_shared/services/helper.service';
import { ChangeWizardTodoStatus, GetAndLoadWizardSettings } from './../../../_shared/state/base/base.actions';
import { BaseState } from './../../../_shared/state/base/base.state';

@Component({
    selector: 'onboarding-wizard',
    templateUrl: './onboarding-wizard.component.html',
    styleUrls: ['./onboarding-wizard.component.scss'],
})
export class OnboardingWizardComponent implements OnInit {
    public setupTodoList = {};
    public todoListKeys: string[];
    public expanded = false;
    private onDestroy$: Subject<void> = new Subject<void>();
    constructor(
        public helper: HelperService,
        private store: Store,
        private toastr: ToastrService,
    ) {
        this.store
            .dispatch(new GetAndLoadWizardSettings())
            .pipe(takeUntil(this.onDestroy$))
            // TODO Ignored with eslint-interactive on 2023-11-10
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            .subscribe(() => {});
    }

    @Select(BaseState.GetOnboardingWizardSettings)
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onBoardingWizardSettings: Observable<any>;

    ngOnInit() {
        this.onBoardingWizardSettings.pipe(takeUntil(this.onDestroy$)).subscribe((wizardSettings: WizardListElement[]) => {
            if (wizardSettings) {
                this.setupTodoList = _.groupBy(_.sortBy(wizardSettings, 'id'), 'group');
                this.todoListKeys = Object.keys(this.setupTodoList);
            }
        });
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/use-lifecycle-interface
    ngOnDestroy(): void {
        this.onDestroy$.next();
    }

    public changeTodoStatus(selectedWizard: WizardListElement, event) {
        const checkedValue: boolean = event.target.checked;
        if (checkedValue && selectedWizard.group === 'Tehnične nastavitve eAmbulante') {
            //Tehnične nastavitve se morajo nastaviti v določenem vrstnem redu
            if (
                this.setupTodoList[selectedWizard.group]
                    ?.slice(
                        0,
                        this.setupTodoList[selectedWizard.group].findIndex(wizard => wizard.id === selectedWizard.id),
                    )
                    ?.every(wizard => wizard.completed === true)
            ) {
                this.store.dispatch(new ChangeWizardTodoStatus({ completed: checkedValue, id: selectedWizard.id }));
            } else {
                this.toastr.warning('Priporočamo, da tehničnim nastavitvam sledite po vrstnem redu.');
                event.target.checked = !checkedValue;
            }
        } else {
            this.store.dispatch(new ChangeWizardTodoStatus({ completed: checkedValue, id: selectedWizard.id }));
        }
    }
    public showMessage(id: number) {
        //message ob kliku na TODO, kjer ni mogoče izvesti direktnega redirecta
        switch (id) {
            case 21:
                this.toastr.info('Izberite obstoječ termin iz koledarja');
                break;
            case 22:
                this.toastr.info('Izberite obstoječo obravnavo iz koledarja');
                break;
        }
    }

    sortAtributes(a, b) {
        return b;
    }
}
